module.exports = __webpack_public_path__ + "static/media/between_text.f0c169fd.jpg";